import { UrlMatcher } from '@angular/router';
import { LangsEnum, ProductsEnum } from '../enums';

const SUPPORTED_LANGS = [`${LangsEnum.EN}`];
const SUPPORTED_PRODUCTS = [
  `${ProductsEnum.INDIVIDUAL}`,
  `${ProductsEnum.BUSINESS}`,
  `${ProductsEnum.AGRO}`,
];

export const homepageMatcher: UrlMatcher = (segments, group, route) => {
  if (segments.length === 0) return { consumed: [] };

  if (segments.length === 1 && SUPPORTED_LANGS.includes(segments[0].path)) {
    return { consumed: segments };
  }

  if (
    segments.length === 2 &&
    SUPPORTED_LANGS.includes(segments[0].path) &&
    SUPPORTED_PRODUCTS.includes(segments[1].path)
  ) {
    return {
      consumed: segments,
      posParams: {
        lang: segments[0],
        product: segments[1],
      },
    };
  }

  return null;
};
